import React from "react";

function Footer() {
  return <div style={{ backgroundColor: "black" }}></div>;
}

export default Footer;
